<script setup lang="ts">
import { computed, nextTick, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import Dropdown from '@/components/partials/Inputs/Dropdown.vue'
import { Distribution } from '@/enums/Distribution'
import type { DropdownItem } from "@/types/form/dropdown"

const props = withDefaults(defineProps<{
  modelValue: Distribution
  distributions?: Distribution[]
  layout?: 'square' | 'borderless'
}>(), {
  // TODO remove this default value, DistributionTypeDropdown should be wrapped in a v-if if establishment is null
  distributions: () => [ Distribution.Delivery, Distribution.TakeAway ],
})

const emit = defineEmits([ 'distChange' ])

const { t } = useI18n()

const key = ref(0)

const distribution = computed({
  get: () => props.modelValue,
  set: async val => {
    emit('distChange', val)

    // im not proud if it, but it works
    await nextTick()
    key.value += 1
  },
})

const items = computed<DropdownItem[]>(() => {
  const available = (distribution: Distribution) => props.distributions.includes(distribution)

  return [
    {
      value: Distribution.Delivery,
      available: available(Distribution.Delivery),
      label: available(Distribution.Delivery) ? t('distribution-toggle.delivery') : t('distribution-toggle.delivery-not-available'),
    },
    {
      value: Distribution.TakeAway,
      available: available(Distribution.TakeAway),
      label: available(Distribution.TakeAway) ? t('distribution-toggle.takeaway') : t('distribution-toggle.takeaway-not-available'),
    },
  ]
})
</script>

<template>
  <Dropdown :items="items" v-model="distribution" :layout="layout" :key="key"/>
</template>
